import React, { useState, useEffect } from 'react';
import api from '../api';
import Layout from '../components/Layout';

export default function Partners() {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [uploadingLogo, setUploadingLogo] = useState(false);
  const [form, setForm] = useState({ name: '', logo_url: '', website_url: '', display_order: 0 });

  const fetchPartners = async () => {
    setLoading(true);
    try {
      const res = await api.get('/partners/admin/all');
      setPartners(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPartners();
  }, []);

  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) {
      alert('Ukuran logo maksimal 5MB');
      e.target.value = '';
      return;
    }
    setUploadingLogo(true);
    try {
      const fd = new FormData();
      fd.append('photo', file);
      const res = await api.post('/upload/partner-logo', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setForm((f) => ({ ...f, logo_url: res.data.url }));
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal upload logo');
    } finally {
      setUploadingLogo(false);
    }
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.logo_url) {
      alert('Nama dan logo wajib diisi');
      return;
    }
    setSaving(true);
    try {
      await api.post('/partners', form);
      setForm({ name: '', logo_url: '', website_url: '', display_order: 0 });
      fetchPartners();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal tambah partner');
    } finally {
      setSaving(false);
    }
  };

  const toggleActive = async (p) => {
    try {
      await api.put(`/partners/${p.id}`, { is_active: !p.is_active });
      fetchPartners();
    } catch (err) {
      alert('Gagal update status');
    }
  };

  const updateOrder = async (p, newOrder) => {
    try {
      await api.put(`/partners/${p.id}`, { display_order: newOrder });
      fetchPartners();
    } catch (err) {
      alert('Gagal update urutan');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Hapus partner ini?')) return;
    try {
      await api.delete(`/partners/${id}`);
      fetchPartners();
    } catch (err) {
      alert('Gagal hapus partner');
    }
  };

  const inputStyle = { background: '#12151A', border: '1px solid #262b33', borderRadius: 6, padding: '10px 12px', color: '#F0EDE4', fontSize: 14, width: '100%' };

  return (
    <Layout>
      <h1 style={{ fontSize: 28, fontWeight: 900, fontStyle: 'italic', marginBottom: 24 }}>Kelola Partners</h1>

      <form onSubmit={handleAdd} style={{ background: '#1C2128', border: '1px solid #262b33', borderRadius: 8, padding: 20, marginBottom: 24, maxWidth: 480 }}>
        <h2 style={{ fontSize: 16, fontWeight: 800, marginBottom: 14 }}>Tambah Partner</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div>
            <label style={{ fontSize: 12, color: '#8B92A0', marginBottom: 4, display: 'block' }}>Nama Partner</label>
            <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} style={inputStyle} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: '#8B92A0', marginBottom: 4, display: 'block' }}>Website (opsional)</label>
            <input value={form.website_url} onChange={(e) => setForm({ ...form, website_url: e.target.value })} placeholder="https://..." style={inputStyle} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: '#8B92A0', marginBottom: 4, display: 'block' }}>Urutan Tampil (angka kecil di depan)</label>
            <input type="number" value={form.display_order} onChange={(e) => setForm({ ...form, display_order: Number(e.target.value) })} style={inputStyle} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: '#8B92A0', marginBottom: 4, display: 'block' }}>Logo</label>
            {form.logo_url && (
              <div style={{ width: 80, height: 80, background: '#12151A', borderRadius: 6, overflow: 'hidden', marginBottom: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img src={form.logo_url} alt="" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
              </div>
            )}
            <label style={{ display: 'inline-block', background: '#262b33', color: '#F0EDE4', padding: '8px 16px', borderRadius: 6, fontSize: 12, cursor: 'pointer' }}>
              {uploadingLogo ? 'Mengupload...' : 'Upload Logo'}
              <input type="file" accept="image/*" onChange={handleLogoUpload} style={{ display: 'none' }} />
            </label>
            <p style={{ fontSize: 10, color: '#5a616e', marginTop: 4 }}>Maks 5MB, format JPG/PNG/WEBP</p>
          </div>
          <button type="submit" disabled={saving} style={{ background: '#D02127', color: '#fff', border: 'none', padding: 12, borderRadius: 6, fontWeight: 700, cursor: 'pointer', marginTop: 8 }}>
            {saving ? 'Menyimpan...' : 'Tambah Partner'}
          </button>
        </div>
      </form>

      <h2 style={{ fontSize: 16, fontWeight: 800, marginBottom: 14 }}>Daftar Partner</h2>
      {loading ? (
        <p style={{ color: '#8B92A0' }}>Memuat...</p>
      ) : partners.length === 0 ? (
        <p style={{ color: '#8B92A0' }}>Belum ada partner.</p>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 14 }}>
          {partners.map((p) => (
            <div key={p.id} style={{ background: '#1C2128', border: '1px solid #262b33', borderRadius: 8, padding: 14, opacity: p.is_active ? 1 : 0.5 }}>
              <div style={{ width: '100%', height: 70, background: '#12151A', borderRadius: 6, marginBottom: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img src={p.logo_url} alt={p.name} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
              </div>
              <p style={{ fontWeight: 700, fontSize: 13 }}>{p.name}</p>
              {p.website_url && <p style={{ color: '#2B6996', fontSize: 11, marginTop: 2, wordBreak: 'break-all' }}>{p.website_url}</p>}
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 8 }}>
                <span style={{ fontSize: 11, color: '#8B92A0' }}>Urutan:</span>
                <input
                  type="number"
                  defaultValue={p.display_order}
                  onBlur={(e) => updateOrder(p, Number(e.target.value))}
                  style={{ width: 50, background: '#12151A', border: '1px solid #262b33', color: '#F0EDE4', padding: '3px 6px', borderRadius: 4, fontSize: 11 }}
                />
              </div>
              <div style={{ display: 'flex', gap: 6, marginTop: 10 }}>
                <button
                  onClick={() => toggleActive(p)}
                  style={{
                    flex: 1, background: p.is_active ? 'rgba(74,222,128,0.15)' : 'rgba(139,146,160,0.15)',
                    color: p.is_active ? '#4ADE80' : '#8B92A0', border: 'none', padding: '6px 0', borderRadius: 4, fontSize: 11, fontWeight: 700, cursor: 'pointer',
                  }}
                >
                  {p.is_active ? 'Aktif' : 'Nonaktif'}
                </button>
                <button
                  onClick={() => handleDelete(p.id)}
                  style={{ flex: 1, background: 'rgba(208,33,39,0.15)', color: '#D02127', border: 'none', padding: '6px 0', borderRadius: 4, fontSize: 11, fontWeight: 700, cursor: 'pointer' }}
                >
                  Hapus
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </Layout>
  );
}
